module.exports = __webpack_public_path__ + "img/四川天府七中.3d03c8c8.jpg";